import { Chip, Stack, IconButton, Tooltip } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import moment from 'moment';

// Canonical messageLog status set used for status-cell rendering.
type AllMessageStatus =
    | 'pending'
    | 'before-wa-send'
    | 'bt-sent'
    | 'confirmed'
    | 'received'
    | 'read'
    | 'played'
    | 'cancelled'
    | 'failed';

interface StatusCellProps {
    status?: AllMessageStatus | string;
    dueDate?: string | Date;
}

const getStatusColor = (status: AllMessageStatus) => {
    switch (status) {
        case 'bt-sent':        return '#4CAF50';
        case 'before-wa-send': return '#42A5F5';
        case 'pending':        return '#FFA726';
        case 'confirmed':      return '#2E7D32';
        case 'received':       return '#1B5E20';
        case 'read':
        case 'played':         return '#1B5E20';
        case 'cancelled':
        case 'failed':         return '#D32F2F';
        default:               return '#757575';
    }
};

export const StatusCell = ({ status, dueDate }: StatusCellProps) => {
    const isFutureMessage = dueDate && moment(dueDate).isAfter(moment());
    const statusValue = (status as AllMessageStatus) || 'pending';

    return (
        <Stack direction="row" spacing={1} alignItems="center">
            <Chip 
                label={statusValue}
                size="small"
                sx={{
                    backgroundColor: getStatusColor(statusValue),
                    color: 'white',
                    fontWeight: 'bold',
                    textTransform: 'capitalize'
                }}
            />
            {isFutureMessage && (
                <Tooltip title={moment(dueDate).format('MMM D, HH:mm')}>
                    <IconButton 
                        size="small" 
                        sx={{ 
                            color: '#9C27B0',
                            padding: '2px'
                        }}
                    >
                        <AccessTimeIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            )}
        </Stack>
    );
}; 